import React from 'react'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailRowItem from 'src/shared/components/data-display/Detail/kit/DetailRowItem/DetailRowItem'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'
import Icon from 'src/shared/icons'
import { IconNameType } from 'src/shared/types/IconNameType'

const PagoPendienteDetails = ({ iconName, title, onPrint, payments, date }: {
    iconName: IconNameType, title: string, date: string, onPrint?: () => void, payments: {
        label: string;
        amount: number;
    }[]
}) => {
    return (
        <Detail>
            <DetailIcon name={iconName} />
            <DetailContent>
                <DetailRow>
                    <DetailText>
                        {title}
                    </DetailText>
                    {
                        !!onPrint &&
                        <DetailRowItem style={{ textAlign: "right" }}>
                            <Icon name='printer' width={16} height={16} color='var(--white)' onClick={onPrint} />
                        </DetailRowItem>
                    }
                </DetailRow>
                {
                    payments.map(p => (<>
                        <DetailRow>
                            <DetailText type='bold'>
                                {p.label}
                            </DetailText>
                            <DetailText type='bold' textAlign='right'>
                                {formatCurrencyToFixed(p.amount)}
                            </DetailText>
                        </DetailRow>
                    </>))
                }
                <DetailRow>
                    <DetailText>
                        {date}
                    </DetailText>
                </DetailRow>
            </DetailContent>
        </Detail>
    )
}

export default PagoPendienteDetails